import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const ArrowSideMenuLinkDefaultIcon = styled.div<{active?: boolean}>`
    display: block;
    width: 2rem;
    height: 2rem;
    background-image: url(${({theme}) => theme.images.spriteSheet.toString()});
    background-repeat: no-repeat;

    ${CssRule.For.RTL.build()} & {
        transform: scaleX(-1);
    }

    background-position: -762px -651px;
`;

const ArrowSideMenuLinkCasino777Icon = styled(ArrowSideMenuLinkDefaultIcon)`
    background-position: -611px -491px;
`;

export const ArrowSideMenuLinkIcon = styledByTheme(ArrowSideMenuLinkDefaultIcon)
    .forCasino777(ArrowSideMenuLinkCasino777Icon)
    .apply();
